import moment from 'moment';

export default {
  chartsData: {
    'hour-stats': { total: 0, growth: 0, points: [] },
    'day-stats': { total: 0, growth: 0, points: [] },
    'month-stats': { total: 0, growth: 0, points: [] },
    'year-stats': { total: 0, growth: 0, points: [] },
    advertisers: { top: [] },
    artists: { top: [] },
    categories: { top: [] },
    countries: { top: [] },
    decades: { top: [] },
    genres: { top: [] },
    tracks: { top: [] },
    stations: { top: [], area: [] },
    local_vs_international: { points: [{ local: 0, international: 0 }] },
    sold_out: {
      hours: {
        '00:00': 0,
        '01:00': 0,
        '02:00': 0,
        '03:00': 0,
        '04:00': 0,
        '05:00': 0,
        '06:00': 0,
        '07:00': 0,
        '08:00': 0,
        '09:00': 0,
        '10:00': 0,
        '11:00': 0,
        '12:00': 0,
        '13:00': 0,
        '14:00': 0,
        '15:00': 0,
        '16:00': 0,
        '17:00': 0,
        '18:00': 0,
        '19:00': 0,
        '20:00': 0,
        '21:00': 0,
        '22:00': 0,
        '23:00': 0,
      },
    },
  },
  selectedDate: moment(),
  selectedPeriod: 'month',
  selectedStation: null,
  stations: [],
  loadingCharts: false,
  loadingChartsFailed: false,
  loadingChartsError: null,
  loadingChartsSucceeded: false,
  loadingStations: false,
  loadingStationsFailed: false,
  loadingStationsSucceeded: false,
  loadingStationsError: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/afstereo/state.js